export function getLogData() {
    return logData
}

const logData = [
    {
        sysName: '交付系统',
        updateLog: [
            {
                updateTime: '2026/10/28',
                content: [
                    '界面新增智能体弹窗，支持选择项目号 / 合同号 搜索，选定后直接跳转解读界面',
                    '界面新增 凌博士组学智能体Pro 悬浮球，支持快捷进入报告解读，并保留上次选择',
                    '快捷入口功能  第一次默认自动填充 项目号以及具体分析号，方便客户一键体验',
                    '分析管理界面新增  [一键解读]  快捷入口，方便客户快速开启智能解读',
                    '优化分析内 凌博士组学智能体Pro 图标展示',
                    '界面新增红色字体提示：(注: 点击进入项目/分析)',
                ]
            },
            {
                updateTime: '2026/09/15',
                content: [
                    '优化多样性、转录组、代谢组AI报告解读，右侧统一显示目录结构，可对目录中所有文件进行解读，并增加解读模版',
                    '优化转录组、代谢组AI报告解读多组解读模板',
                    '新增AI报告解读操作流程图解',
                ]
            },
            {
                updateTime: '2026/08/07',
                content: [
                    '自动分析邮件抄送人修改，由抄送韩艺修改为抄送对应处理人主管',
                ]
            }, {
                updateTime: '2026/05/21',
                content: [
                    '分析人员可以看见所有项目',
                ]
            },
            {
                updateTime: '2026/05/09',
                content: [
                    '修复分析员新建项目时频繁上传失败的问题，提升项目创建及文件上传稳定性',
                ]
            },
            {
                updateTime: '2026/04/03',
                content: [
                    '优化图形绘制全流程界面，升级绘制中加载提示与绘制失败报错界面，提升用户体验',
                    '绘制中新增统一风格的加载弹窗，搭配动态动画，清晰告知渲染状态',
                    '重构绘制失败弹窗，明确失败状态，完整保留报错日志，方便问题定位',
                ]
            }, {
                updateTime: '2025/12/29',
                content: [
                    '打通微课云和交付系统的账号登录并将微课云放在交付系统中',
                ]
            },
            {
                updateTime: '2025/12/12',
                content: [
                    '结果图片增加格式tiff，增加打印功能',
                    '优化UI',
                ]
            },
            {
                updateTime: '2025/12/1',
                content: [
                    '所有涉及样本分组的结果支持选择样本分组进行分析（完成转录组、宏基因组、代谢组）',
                    '所有系统完成结果目录功能。',
                ]
            },
            {
                updateTime: '2025/11/28',
                content: [
                    '原始数据到期邮件标题修改为 凌恩生物-原始数据-剩余时间提醒',
                    '裸测邮件样本使用附件发送',
                ]
            },
            {
                updateTime: '2025/11/25',
                content: [
                    '高亮展示教学视频',
                ]
            },
            {
                updateTime: '2025/11/03',
                content: [
                    '自定义绘图方案中期刊配色更新',
                ]
            },
            {
                updateTime: '2025/09/26',
                content: [
                    '报告审批、裸测审批新增“样品数据量”列',
                    '原始数据支持复制下载链接'
                ]
            },
            {
                updateTime: '2025/09/12',
                content: [
                    '未释放的项目列表可见但不可操作',
                ]
            }, {
                updateTime: '2025/08/01',
                content: [
                    '设置报告审批超时提醒邮件只会在法定工作日发送 跳过法定节假日',
                    '新增备注（客户自填）列（客户可以对自己的项目进行备注）',
                ]
            }, {
                updateTime: '2025/06/20',
                content: [
                    '新增项目使用情况页面(管理员、销售可见)，统计用户和项目活跃度'
                ]
            }, {
                updateTime: '2025/06/06',
                content: [
                    '界面ui优化',
                    '新增样本信息和样本数量'
                ]
            },
            {
                updateTime: '2025/04/10',
                content: [
                    '联系我们界面增加数据库和服务器平台搭建服务链接'
                ]
            }, {
                updateTime: '2025/03/28',
                content: [
                    '新增联系我们',
                ]
            },
        ]
    },
    {
        sysName: '多样性交付系统',
        updateLog: [
            {
                updateTime: '2026/10/23',
                content: [
                    '项目详情界面增加分析软件和参数说明，多样性项目和功能基因项目报告名称区分',
                    '功能基因项目与1.0多样性项目增加分析水平展示',
                    'PICRUSt2功能预测/KEGG 功能预测结果统计增加重绘功能',
                    '生态位分析/生态位宽度分析/物种群落丰度与生态位宽度散点图各分组情况增加颜色重绘参数',
                    'MaAsLin2 差异分析增加字体/颜色可调节参数',
                    '网络图模块增加说明，分组数大于 10 时，系统只输出样本级网络结果',
                    '解决部分项目数据统计及ASV聚类注释/ASV聚类和物种注释 抽平结果显示异常的问题',
                    '解决部分项目结果文件显示问题',
                    '解决部分项目Beta多样性分析/PCOA分析 模块报错的问题',
                ]
            },
            {
                updateTime: '2026/10/10',
                content: [
                    '解决差异分析/Wilcoxon-组间丰度差异物种识别图中组名对应不一致的问题',
                    '优化物种组成分析 / 组间-堆积冲击图的展示效果，横坐标角度调为0图例默认展示成居中',
                    '有分组分析增加样本数量限制500，避免因为样本过多导致在某个步骤不动的问题',
                    'Alpha多样性分析/Alpha Diversity指数差异箱线图增加x轴文字倾斜角度调整功能',
                    '增加样本名样本信息导出功能，显示样本名最初列和现有修改后列',
                    '解决差异分析/ LEfSe分析重绘失败的问题',
                    '解决Beta多样性分析/PCA分析组名调整无效的问题',
                    '解决差异分析 / LEfSe分析 LEfSe LDA值分布柱状图没有颜色的问题',
                    '解决部分分析NRI、NT1、NST分析缺失的问题',
                    '增加LEfSe进化分支图、LEfSe LDA值分布柱状图背景线颜色参数',
                    '解决差异分析/ Wilcoxon-组间丰度差异物种识别组名和图名对不上的问题',
                ]
            },
            {
                updateTime: '2026/09/11',
                content: [
                    '增加FAPROTAX功能预测/功能预测beta多样性分析、功能预测相对丰度组间差异展示 模块图的重绘功能',
                    '解决Core共有物种分析/组间-差异分析、组间-核心ASVs分析由于组间物种差异过少导致的报错',
                    '解决Core分析当核心物种的Species水平全是Unclassified 的时候 sankey图画不出来的问题',
                    '解决部分项目报告下载异常的问题',
                    '解决游客账号项目的部分分析的报错以及提供现版本正确的分析示例',
                    '解决差异分析/组间差异气泡图分组数量与实际分组数量不一致的问题',
                    '解决部分分析物种群落构建机制/零模型分析报错的问题',
                    '样式选择功能上线 部分图可以自主选择：主题、网格与辅助线、坐标轴、图例、图版与背景进行细致的样式修改',
                    '解决部分项目Alpha多样性分析/Alpha Diversity指数差异箱线图报错的问题',
                    '解决部分项目分析结果目录文件映射错误导致名称对应失败的问题',
                    '解决部分项目丰度表缺失的问题',
                    '生态位分析/生态位宽度分析/物种群落丰度与生态位宽度散点图展示各分组情况并增加对应调图参数',
                    '解决Core分析/top物种分析重绘失败的问题',
                    '增加所有箱线图是否显示须端横线的重绘参数功能',
                ]
            },
            {
                updateTime: '2026/08/12',
                content: [
                    '多样性交付系统拆分出 功能基因扩增子交付系统',
                    '解决部分项目功能预测无法正常生成结果的问题;',
                    '解决部分项目分析结果页面显示异常的问题;',
                    '增加物种群落构建机制/零模型分析bNTI指数图的重绘功能;',
                    '解决部分项目由于样本数过少3D PCA图无法绘制导致的整个模块报错;',
                    '优化Beta多样性分析/beta多样性距离样本两两间距离矩阵表的输出格式;',
                ]
            },
            {
                updateTime: '2026/08/07',
                contentArr: [
                    {
                        title: '1.0',
                        content: [
                            '上线功能基因多样性，支持新建分析页面加入分析水平参数，分类水平起始级别：选门表示门-种，选纲表示纲-种，选目表示目-种，选科表示科-种，选属表示属-种，选种表示仅种水平',
                            '统一补齐降维分析图的「图例位置」与「XY轴范围」参数配置 ，默认值与新增参数前保持一致',
                            '差异分析热图、气泡图图表工具增加物质顺序调整的可选参数',
                            '差异分析/LEFSE分析 LEfSe进化分支图增加LDA值可选参数',
                            '统一补齐降维分析图的「图例位置」与「XY轴范围」参数配置 ，默认值与新增参数前保持一致'
                        ]
                    },
                    {
                        title: '2.0',
                        content: [
                            '差异分析热图、气泡图图表工具增加top数的可选参数',
                            '优化环境因子上传失败的报错信息，增加具体命名规则：须以字母开头，仅允许字母、数字、下划线(_)、中划线(-)，不能包含空格或其他特殊字符',
                            '优化项目上传创建默认分析的逻辑：之前无论分组数量多少都会直接创建有分组，分组过多导致分析异常，现对于分组过多的项目会默认创建无分组项目',
                            '解决部分项目分析管理提示服务器错误的问题',
                            '优化数据统计及OTU聚类注释/OTU聚类和物种注释抽平和未抽平数据的显示逻辑',
                            '解决部分项目差异分析无结果的问题',
                            '优化组间共享核心物种为0时模块的展示',
                            '解决物种组成分析-组间堆积冲击图、组间气泡图等图图表工具分组样本名称异常的问题',
                            '优化样本名的修改逻辑，现在支持链式改名',
                            '解决差异分析/差异比较火山图图和表的数据不一致的问题',
                            '增加韦恩图/花瓣图 可以显示百分比 的选项',
                            '优化网络图错误信息的展示，避免多数由于数据过少导致的页面错误',
                            '解决分析下载的结果报告中数据统计及ASV聚类注释/数据统计表和图缺失的问题',
                            '增加物种组成分析 / 样本-气泡图图例的展示功能、并且优化掉数据过多导致的作图数据下载失败问题',
                            '解决大部分分类学水平没有按照门纲目科属种排列的问题',
                            '解决差异分析 / 组间差异气泡图 字体参数设置无失效的问题',
                        ]
                    },

                ]

            }, {
                updateTime: '2026/07/14',
                content: [
                    '增加 环境因子/CCA/RDA分析特定输出结果供下载',
                    '优化报告中无差异时物种进化分支图和LDA值分布柱状图的展示',
                    '解决 Alpha多样性分析/Alpha Diversity指数差异箱线图中Dunn的默认分组顺序与分组文件不一致的问题',
                    '优化 差异分析 / 物种相对丰度组间差异TOP10模块的说明文字',
                    '优化部分项目点击分析管理出现服务器错误的问题',
                    '优化新建分析逻辑，现在每个项目中如果存在三个以上的分析正在运行，新建分析会出现提示暂时不允许新建',
                    '解决部分项目 Alpha多样性分析/ Alpha Diversity指数差异箱线图模块错误的问题',
                    '解决部分项目 物种组成分析模块部分pdf存在分组或者样本数与实际不匹配的问题',
                    '解决部分项目 差异分析/Wilcoxon-组间丰度差异物种识别无结果的问题',
                    '增加 环境因子 / 主要物种丰度与环境因子相关性可选top数进行重绘',
                    '解决部分项目 环境因子/Mantel test模块错误的问题',
                    '解决部分项目 网络图 / 组间-分析结果模块错误的问题',
                    '解决部分项目 物种群落构建机制 / Rao分析重绘失败的问题',
                    '增加  物种群落构建机制/ NTI分析/DDCS-Bray_Curtis_group.pdf作图数据的下载',
                    '优化多样性和代谢联合分析交付系统创建项目接口的相应速度，检索速率整体提升90%',
                    '针对无分组Bray Curtis距离3D-PCOA图标签设置到点旁边',
                    '优化系统中标题展示：善于绘图，精于解读'
                ]
            }, {
                updateTime: '2026/07/02',
                content: [
                    'LEFSE进化分支图增加调颜色参数设置',
                    '优化LEFSE没有差异结果的展示，不会出现暂无图片',
                    '解决Alpha多样性指数差异箱线图重绘错误的问题',
                    '增加10.PICRUSt2功能预测 /03.功能注释相对丰度展示、02.Alpha多样性分析/03.Alpha Diversity曲线、09.FAPROTAX功能预测/04.功能预测相对丰度组间差异等作图数据下载的功能',
                    '解决06.差异分析/10.Indicator组间指示物种识别表格错位的问题',
                    '解决上传文件出现服务器错误，问题不清晰的问题',
                    '解决点击新建分析后新建分析框不能自动隐藏的问题',
                    '增加部分报告说明文字',
                    '解决06.差异分析/05.物种相对丰度组间差异TOP10初始分组顺序异常的问题，增加dunn图重绘功能',
                    '解决部分分析06.差异分析 / 05.物种相对丰度组间差异TOP10页面错误的问题',
                    '解决部分项目点击分析管理出现服务器错误异常展示的问题',
                    '解决12.Function_Tax4Fun2/01.Predict_result/predicted_result.txt结果是总样本的丰度表的问题'
                ]
            },
            {
                updateTime: '2026/06/18',
                content: [
                    '优化环境因子作为一个独立模块 和主流程分开独立运行',
                    '解决Core分析/组间-核心物种识别五组画不出Venn图的问题',
                    '优化Lefse模块，加表头和加分类标签，默认都分析到种水平',
                    '解决差异分析/LEfSe分析 颜色和分组顺序修改出错的问题',
                    '增加Beta多样性分析/PCOA分析 修改分组颜色的功能',
                    '优化物种群落丰度与生态位宽度散点图重绘出图效果',
                    '优化网络图错误提示，页面展示具体过滤流程',
                    '解决Core分析/top物种分析  top数量设置异常  颜色顺序修改异常的问题',
                    '解决无分组报告部分缺图缺表的问题',
                    '优化合并分析失败的错误提示',
                    '多样性2.0增加对k__Archaea的兼容，避免异常过滤导致的运行失败',
                    'Lefse分析增加Lefse_LDA 差异物种结果表格的展示',
                    '解决项目样本管理界面——样本名重复的问题',
                    '新增无分组分析暂无AI报告解读提示，支持跳转 分析管理 界面',
                ]
            },
            {
                updateTime: '2026/06/05',
                content: [
                    "优化并完善 LEFSE 流程",
                    "优化项目合并流程，优化多项目合并后的结果",
                    "解决 LEfSe LDA 值分布柱状图自定义参数失效的问题",
                    "解决 06. 差异分析 / 09.LEfSe 分析部分图没有作图数据的问题",
                    "解决 05.Beta 多样性分析 / 05.NMDS 分析 / 06 差异分析作图数据下载为空的问题",
                    "解决 06. 差异分析 / 11.Ternary 三元相图数值对应异常的问题",
                    "增加可生成 01.DataStat/01.Read.stat/ 的统计结果的功能",
                    "解决 03. 物种组成分析 / 13. 样本 - 未聚类热图 top 数量失效的问题",
                    "优化合并效率，解决部分项目合并时间过长的问题",
                    "解决 03. 物种组成分析 / 01. 各样本的分类学丰度统计层级不对应的问题",
                    "解决生态位宽度分析比较图结果异常的问题",
                    "解决 06. 差异分析 / 06.Wilcoxon - 组间丰度差异物种识别修改颜色不生效的问题",
                    "增加 LEfSe LDA 值分布柱状图 / 进化分支图 LDA 值可调节选项",
                    "解决部分项目缺少图表的问题",
                    "解决下载的分析报告格式错误的问题"
                ]
            },
            {
                updateTime: '2026/05/21',
                content: [
                    "AI 报告智能解读功能全新上线，支持基于Alpha 多样性、Beta 多样性、物种组成、核心物种、差异分析、功能预测全套扩增子分析结果文件，自动生成专业学术解读内容，覆盖微生物多样性分析全流程报告智能解读",
                    "内置6 套专业化场景提示词模板，开箱即用，无需复杂配置即可一键完成标准学术解读，适配环境样本、作物根际、肠道微生物等主流科研项目。",
                    "模板1：Alpha 多样性专项解读，支持导入 Alpha 多样性指数、差异检验结果及分组文件，自动筛选显著差异指数、解析各指数组间变化趋势，结合实验设计生成结论并配套可引用参考文献",
                    "模板 2：Beta 多样性专项解读，基于 PCoA 结果、Adonis/ANOSIM 组间检验文件，自动判别分组分离效果、组间差异显著性，智能评估离群样本重复性及是否建议剔除",
                    "模板 3：物种组成分布解读，导入门 / 属 / 种水平物种丰度表与分组信息，自动统计各分类水平 Top10 物种、组间占比及变化趋势，直接生成可粘贴至论文的标准结果描述与图注文字",
                    "模板 4：核心物种专属解读，依托 ASV/OTU 丰度表与分组文件，筛选 ASV 及各分类水平核心物种，统计组间共有 / 特有物种数量，并解析特有物种所属门、属、种分布特征",
                    "模板 5：差异分析深度解读，兼容 Lefse、MaAsLin2 差异分析结果及物种丰度表，结合研究背景与已发表文献，筛选关键差异物种、关联肠道 / 环境益生菌功能，提供文献支撑与机制说明。",
                    "模板 6：群落功能预测组合解读，整合 PICRUSt2 功能预测、核心物种及差异物种结果，智能解析群落核心功能变化趋势、处理因素对功能通路的影响，阐释微生物群落与功能的互作规律",
                    "为每个项目提供 2000 万 token 免费额度，满足日常解读与多轮对话使用",
                    "支持管理员与技术支持人员手动修改项目 token 额度",
                    "新增生成核心物种识别各个组独有的物种数据表",
                    "PCA图增加XY轴范围自定义调整",
                    "修复部分项目没有NTI分析的问题",
                    "优化内存占用，解决部分项目内存超限运行失败的问题",
                    "修复04.Core分析-02.组间-核心物种识别-venn图重绘失败的问题",
                    "修复03.物种组成分析-04.组间-堆积冲击图删除others标签无效的问题",
                    "解决FAPROTAX top10功能分类组间差异气泡图和FAPROTAX 功能注释相对丰度堆积冲击图显示异常的问题",
                    "在分析管理界面-分组样本信息，可以展示正确的分组顺序",
                ]
            },
            {
                updateTime: '2026/05/09',
                content: [
                    '优化环境因子文件不规范导致的大多数模块报错问题',
                    '韦恩图和花瓣图增加自定义参数重绘功能',
                    '优化项目合并功能，缩短合并时间',
                    '解决部分项目零模型分析的βNTI值异常的问题',
                    '解决报告中PCOA图的PC1、PC2值和系统不一致的问题',
                    '增加LEfSe进化分支图的作图数据文件',
                    '解决Alpha多样性分析/Alpha Diversity指数差异箱线图中的组数和实际组数不一致的问题',
                    '解决部分项目缺失分析上传结果的问题',
                    '解决LEfSe差异菌的LDA效应值条形图重绘报错的问题',
                    '解决物种组成分析部分模块图表工具和top数量调整无效的问题',
                    '优化过滤逻辑，样本名不符合命名规范（不能等于a/b/c或L1/L2/L3）新建分析会报错',
                    '解决组名存在下划线导致的项目报错问题',
                    '优化注释比例统计圆环图的默认层级顺序，按照门纲目科属种排序以及优化分组过多颜色过少导致的报错',
                    '解决Core分析/Dominant物种分析饼图标签位置异常的问题',
                ]
            },
            {
                updateTime: '2026/04/03',
                content: [
                    '解决部分项目分组数超限制的问题',
                    '优化部分分析超内存导致运行失败的问题',
                    '解决堆积冲击图修改TOP数没变化的问题',
                    '解决部分分析Wilcoxon-组间丰度差异物种识别、Indicator组间指示物种识别、组间差异热图报错的问题',
                    '解决Core共有物种分析-组间核心ASVs分析出空白图的问题',
                    '解决无分组实际图和报告图不一致的问题',
                    '解决无分组部分分析运行异常(不出结果)的问题',
                    '解决部分分析PCoa图颜色和图表工具失效的问题',
                    '解决部分分析生态位分析、种群落构建机制、生活史特征分析部分绘图失败的问题',
                    '解决超过20分组但颜色不足导致的运行失败问题',
                    '新增差异热图可以自行选择数值或者差异标签显示的功能'
                ]
            },
            {
                updateTime: '2026/03/27',
                content: [
                    '解决PICRUSt2功能预测/功能注释相对丰度展示-样本PICRUSt功能注释相对丰度堆积冲击图绘图报错的问题',
                    '解决部分模块新建分析时设置的颜色与实际跑出来的分组颜色不一致的问题，具体如下：Alpha多样性分析/Alpha Diversity指数差异箱线、Core分析/组间-核心物种识别、Core分析/样本-核心物种识别、Core分析/Dominant物种分析、Beta多样性分析/beta多样性距离可视化、Beta多样性分析/PCA分析、Beta多样性分析/PCoA分析、Beta多样性分析/NMDS分析、Beta多样性分析/beta多样性距离的UPGMA聚类、Beta多样性分析/t-SNE降维分析、Beta多样性分析/UMAP降维分析、差异分析/LEfSe分析、生态位分析/生态位宽度分析、物种群落构建机制/beta-deviation指数、物种群落构建机制/NST分析、物种群落构建机制/零模型分析、生活史特征分析/Body size分析、生活史特征分析/GC含量、生活史特征分析/核糖体拷贝数分析',
                    '解决部分分析因分组颜色过多导致的绘图失败问题',
                    '解决Beta多样性分析/PCoA分析初始颜色异常和剔除样本无效果的问题',
                    '新增Beta多样性分析/PCoA分析legend标题大小和legend大小的修改功能 避免分组过多导致的遮挡问题'
                ]
            }, {
                updateTime: '2026/03/20',
                content: [
                    '解决差异分析-组间差异热图空白的问题',
                    '解决Beta多样性分析-beta多样性距离聚类的层次聚类图样本名太长导致的遮挡问题',
                    '解决部分分析没alpha多样性指数表和箱线图的问题',
                    '解决部分项目PICRUSt2功能预测/功能预测beta多样性分析模块报错的问题',
                    '解决部分项目引物原始数据下载失败的问题',
                    '解决环境因子-主要物种丰度与环境因子相关性/环境因子-环境因子与alpha多样性相关性模块失败的问题',
                    '解决部分项目模板匹配失败 出现显示异常的问题',
                    '解决部分项目上传失败的问题',
                    '优化功能预测Faprotax 的层次聚类图、增加功能预测Faprotax 的层次聚类图的重绘功能',
                ]
            }, {
                updateTime: '2026/03/13',
                content: [
                    '新增02.Alpha多样性分析/03.Alpha Diversity曲线、06.差异分析/08.差异比较火山图、07.环境因子/09.MRM分析、07.环境因子/11.地理因子Mantel test分析、08.随机森林分析/03.RF识别关键环境因子、10.PICRUSt2功能预测/03.功能注释相对丰度展示、14.物种群落构建机制/01.中性位模型分析、14.物种群落构建机制/02.betapart分析、14.物种群落构建机制/06.Rao分析等模块的重绘',
                    '优化图表工具：解决了很多模块修改了样本名或者分组名的顺序但实际无法完成的问题',
                    '修复环境因子/02.CCA/RDA分析相同数据只有组名不同但结果不一致的问题',
                    '解决03.物种组成分析/08.样本-气泡图和03.物种组成分析/09.组间-气泡图重绘失败的问题',
                ]
            },
            {
                updateTime: '2026/03/09',
                content: [
                    '修复组间-堆积冲击图、组间-水平柱状图  重绘出现空白图的问题',
                    '修复分组-未聚类热图  分组-聚类热图 重绘失败的问题',
                    '优化部分分析执行过慢的问题',
                    '优化组名逻辑，与其他系统保持一致',
                    '优化网络图过滤逻辑 解决大部分网络部分执行失败的问题',
                    '解决部分分析Tax4Fun功能预测模块执行失败的问题',
                    '解决差异分析-组间差异气泡图 图中Dunn检验少一组的问题',
                    '优化物种组成分析-组间堆积冲击图的右侧图例的展示方式，选择TOP数大于等于20变成两列',
                    '解决物种组成分析-组间堆积冲击图 部分颜色缺失的问题',
                    '解决物种组成分析模块部分图出绘制空白的问题',
                    'Beta多样性分析增加默认标题',
                    '解决Beta多样性分析同类图PC1、PC2值不一致的问题',
                    '解决分析管理部分由于老分析存在不规范组名导致页面显示异常的问题',
                    '解决部分分析物种组成部分报错的问题',
                    '解决部分分析Beta多样性分析-PCOA PC1比例超过100%的问题',
                    '解决新建分析传入颜色与所选颜色不一致的问题',
                    '增加物种相对丰度组间差异TOP10的带P值表生成',
                ]
            },
            {
                updateTime: '2026/02/04',
                content: [
                    '解决 OTU聚类及注释信息/注释效果统计 少图',
                    '解决 Alpha多样性分析/Alpha Diversity指数 少箱线图',
                    '解决 生活史特征分析/GC含量 报错',
                    '解决 Beta多样性分析/PCoA分析 X轴范围(min-max) Y轴范围(min-max)失效的问题',
                    '解决部分项目 分析管理出现服务器错误的问题',
                    '解决部分项目重绘匹配到2.0导致绘制失败的问题',
                    '解决 Beta多样性分析/PCoA分析 默认参数异常导致重绘失败的问题',
                    '解决 Beta多样性分析/PCoA分析 同样的数据由于代码随机性导致图和数据不一致的问题',
                    '解决部分图重绘参数减少的问题',
                    '增加Beta多样性分析/PCA分析 Legend位置可手动修改的功能',
                    '网络图部分  无分组只生成All的结果  有分组中对于>10组的分析也只生成All结果',
                    '解决pdf无法下载作图数据的问题',
                    '部分绘图在Tukey的基础上增加Dunn Test的pdf',
                    '部分pdf增加二级目录 优化界面展示',
                    '网络图部分  无分组只生成All的结果  有分组中对于>10组的分析也只生成All结果',
                    '修复所有分析都跑了功能预测的问题'
                ]
            },
            {
                updateTime: '2026/01/23',
                content: [
                    '多样性2.0版本上线。新增注释结果分组统计热图、gamma多样性指数、分组和弦图、差异比较火山图、MaAsLin2分析等',
                    '增加Beta多样性分析-PCA分析 Lengend可修改位置的功能，右上、左上、右下、左下等',
                    '解决Core共有物种分析-组件核心OTUs识别重绘失败的bug',
                    '解决功能预测很多模块出错误的问题',
                ]
            },
            {
                updateTime: '2025/12/1',
                content: [
                    'LEfSe LDA值分布柱状图新增可选分类学地位显示功能',
                    '优化合并逻辑：支持多引物类型项目合并',
                ]
            },
            {
                updateTime: '2025/11/13',
                content: [
                    '增加物种组成分析-样本气泡图的作图数据生成',
                    '解决Beta多样性-PCoA分析中带统计学检验的PCoA结果图椭圆超过界限无法展示的问题',
                    '解决部分项目因为由于是纯分析因而无法正确生成报告的问题',
                    '解决部分23年项目无法查看分析的问题',
                    '网络图增加提示',
                    '解决部分项目中原始数据异常的问题',
                    '解决部分项目网络图-网络稳定性结果页面报错的问题',
                    '增加LEFSE LDA图可将实线更换成虚线的选项',
                    '解决部分项目由于分组数量过于庞大导致Beat多样性分析-PCoA分析模块报错的问题',
                    '解决部分项目合并失败的问题',
                    '解决部分项目物种组成分析-各样本的分类学丰度统计模块报错的问题',
                    '增加修改带统计学检验的PCoA图分组示例位置的选项，可支持多位置自定义',
                    '解决部分项目生态位分析、物种群落构建机制、生物史特征分析模块错误的问题',
                    '解决PCoA图重绘无法自定义分组显示的问题',
                    '增加Beta多样性分析，PCA分析、PCoA分析、NMDS分析的图表工具(用户可自定义分组和顺序显示)',
                    '解决相同数据，不同分组新建出分析的P值不一致的问题',
                    '增加根据聚类相似度动态调整页面和报告的功能',
                    '优化网络图的默认参数',
                ]
            },
            {
                updateTime: '2025/09/26',
                content: [
                    '优化分析管理，直接显示对应分组信息',
                    '默认分析添加到分析管理中（该分析不能删除）',
                ]
            },
            {
                updateTime: '2025/09/18',
                content: [
                    '解决OTU/ASV显示异常问题',
                    '默认分析优化，上传项目后会根据分组文件自动创建分析',
                    '优化带统计学检验的PCoA结果图中图例遮挡数据点的问题',
                ]
            },
            {
                updateTime: '2025/09/11',
                content: [
                    '新增生态位分析、物种群落构建机制、生物史特征分析三个模块',
                    '报告更新，新版的报告提供了完整的图片、表格并对整体的结构进行了优化',
                    '新增切换路线(主线路、联通转线、电信专线)，对于下载较慢的情况可以通过切换线路的方式解决',
                    '前端UI风格的升级，现在UI的整体风格保持和宏基因组一致',
                    '老项目默认不执行新流程',
                    '解决06差异分析-02组间差异热图图表工具顺序修改异常的问题',
                    '解决部分项目中06差异分析-01LEFSE报错的问题',
                    '解决06差异分析-06Wilcoxon模块报错的问题',
                    '解决下载报告生成报告为实例报告的问题',
                    '解决veen图生成结果与报告中不一致的问题',
                    '解决Beta多样性分析样本间距离小提琴图、箱线图、散点图无法修改分组顺序的问题',
                    '解决水平组间差异气泡图重绘失败的问题',
                    '解决部分Wilcoxon-组间丰度差异物种识别运行失败的问题',
                    '解决Core共有物种分析共有物种箱线图、散点图、小提琴图无法修改分组顺序的问题',
                    '解决花瓣图数据和报告中不一致的问题',
                    '解决Alpha多样性分析Alpha Diversity指数和报告不一致的问题',
                    '解决部分图片绘制成空白的问题',
                    '解决Tax4Fun功能注释 PCA图标签显示不完全的问题',
                    '解决部分PCoA图重绘失败的问题',
                    '解决部分合并项目进入项目报错的问题',
                    '优化网络图的样式、并且默认存储之前对样式的修改',
                ]
            },
            {
                updateTime: '2025/08/01',
                content: [
                    '新增花瓣图可下载的作图数据',
                    'veen图增加是否填充圆选项',
                    '解决部分报告表格缺失，信息对应不上的问题',
                    '修复合并项目合同号对应不上，样本信息有误的问题',
                    '解决PCA分析图比例数值有误的问题',
                    'pca等涉及分组的分析添加图标顺序调整',
                    '修复veen图填充圆变成椭圆的问题',
                    '解决部分项目项目类型为空的问题',
                ]
            },
            {
                updateTime: '2025/07/15',
                content: [
                    '新增作图历史记录功能，会自动保存三次历史记录',
                    '增加Venn图、LEFSE LDA值分布柱状图自定义分组顺序功能',
                    '修复部分项目报告为模板项目的问题',
                    '解决部分柱状图勾选部分分组后无法复原的问题',
                    '解决部分项目无法绘图的问题',
                    '解决花瓣图部分数值丢失的问题 ',
                ]
            },
            {
                updateTime: '2025/06/20',
                content: [
                    '解决物种组成分析-样本丰度统计结果与生信报告不一致的问题',
                    '解决花瓣图部分数据显示不全的问题',
                    '解决部分项目新建分析报错的问题',
                    '解决部分项目过滤阈值异常的问题',
                ]
            }, {
                updateTime: '2025/05/29',
                content: [
                    '解决02.Alpha多样性指数可视化修改字体或者修改颜色失败的问题',
                    '解决重新运行导致部分模块绘图失败的问题',
                    '修改项目详情描述，增加项目类型字段',
                    '调整差异分析、PICRUSt2功能预测差异分析、Tax4Fun2差异分析模块。对组数大于等于10组的分析：修改他的差异检验方法，移除两组之间的差异检验，移除04.Indicator组间指示物种识别和05.SIMPER-差异物种贡献度分析模块',
                    '优化生成报告的样式',
                    '项目详情-分析信息页新增加载框',
                    '解决部分报告显示异常的问题',
                    '优化OUT表 删除全0行 并对OTU乱序排序',
                    '解决生物信息部分析的在主界面没有下载结果问题'
                ]
            }, {
                updateTime: '2025/05/06',
                content: [
                    '新增合并项目功能(引物类型、生物序列分类方法需要一致  每个项目只能合并一次)',
                    '解决PCoA、PCA图片椭圆显示不全，坐标无法调整的问题',
                    '修复新建分析页面输入的分组颜色与多个模块中的图不对应的问题',
                    '解决部分项目显示异常的问题',
                    '解决环境因子分析/CCA/RDA分析、db-RNA无法生成作图数据的问题',
                    '解决样本-堆积冲击图，自定义样本排序，排好以后绘制图片没有变化的问题',
                    '解决样本名修改重复但通过校验的问题',
                    '解决堆积条形图绘图颜色不对应的问题',
                    '解决SIMPER-差异物种贡献度分析模块表格显示异常的问题'
                ]
            }, {
                updateTime: '2025/03/28',
                content: [
                    '界面ui优化',
                ]
            }, {
                updateTime: '2024/02/11',
                content: [
                    '解决修改样本名称跟原有原本名称重复情况',
                    '解决网络图模块重绘异常问题',
                    '解决差异分析模块无法下载表的问题',
                    '解决Alpha多样性分析模块没有作图数据的问题',
                    '解决Alpha多样性分析模块文件不存在导致的运行失败问题',
                    '解决交付平台做出来的LEFSE柱状图和报告中给出的不一样的问题',
                    '老项目新建分析移除功能预测功能并提示版本过低',
                    '报告上传路径修改',
                ]
            },
        ]
    },
    {
        sysName: '宏基因组交付系统',
        updateLog: [
            {
                updateTime: '2026/10/23',
                content: [
                    'Binning 流程：支持 metabat2, SemiBin2,QuickBin三种软件进行 binning，保留旧流程兼容',
                    'Binning分析增加模块MAGs 进化树',
                    '解决部分top5基因丰度宿主分析top参数修改异常的问题',
                    '解决 随机森林分析 结果图字体显示异常的问题',
                ]
            },
            {
                updateTime: '2026/09/15',
                content: [
                    '宏基因组AI报告解读上线，支持对物种分析、功能分析、溯源分析，Binning分析结果进行解读',
                    'AI报告解读提供9个模板：5个通用模板和4个binning专属模板',
                    '右侧显示文件结构和分组样本、水平、数据库等信息',
                    '增加解读操作流程图解，包含AI使用技巧，帮助用户规范提问，提升AI解读准确性',
                    'AI输入框不仅支持折叠/收缩 还支持自定义拉伸，为对话列表释放更多展示空间',
                    '为每个项目提供 2000 万 token 免费额度，满足日常解读与多轮对话使用',
                    '解决部分项目物种注释筛选报错',
                    '解决项目功能分析 丰度热图图例数字显示异常',
                ]
            },
            {
                updateTime: '2026/08/14',
                content: [
                    '新建分析增加参数"是否输出种级分类"',
                    '溯源分析增加top参数',
                    '解决界面  类型  列无法搜索的问题',
                    '解决物种分析柱状图分组顺序和新建分析选择分组顺序不一致的问题',
                ]
            }, {
                updateTime: '2026/08/10',
                content: [
                    '正式上线 Spike‑in 绝对定量宏基因组分析；',
                    'Spike‑in 绝对定量每份分析报告同时输出绝对丰度与相对丰度两套结果；',
                    'Spike‑in 绝对定量的分析结果页面，支持两种丰度模式一键切换查看。',
                    'Spike-in 绝对定量绝对丰度分析详情页新增丰度单位，完善数据展示规范性。',
                    'Spike-in 绝对定量分析管理页面区别：点击分析号不跳转，点击相对丰度、绝对丰度可正常跳转，同时为“相对丰度”“绝对丰度”选项增加底色区分；',
                    '功能丰度统计气泡图新增 top 参数。',
                    '修复 LEfSe 分析分组顺序调整不生效的问题。',
                    '修复功能分析模块部分数据库结果展示异常的问题。',
                ]
            }, {
                updateTime: '2026/07/14',
                content: [
                    '解决报告中样本数量显示异常的问题',
                    '解决部分项目内容图片缺失的问题',
                    '优化物种注释筛选，解决SARG筛选后可能报错异常的问题',
                ]
            }, {
                updateTime: '2026/06/05',
                content: [
                    "数据状态提示优化：不符合分析条件的数据库或水平将显示为灰色，点击可查看具体原因",
                    "分析模块执行条件添加：网络分析需分类水平物种数量 ≥ 200 时才执行，功能分析-Beta分析需Subtype 分类数量 ≥ 5 时才执行，溯源分析 (COG/KEGG)需样本数量 < 150 时才执行",
                    "解决部分项目差异分析—lefse分析缺少种水平",
                    "解决部分项目进入分析界面报错"
                ]
            },
            {
                updateTime: '2026/05/15',
                content: [
                    '优化PCA图置信椭圆，解决项目的pca带置信椭圆图超过边界的问题',
                    '解决项目下载的报告中无html报告的问题',
                ]
            },
            {
                updateTime: '2026/04/13',
                content: [
                    '功能分析模块新增水平差异比较气泡图。支持 Type/Subtype 展示，默认展示 Top30 功能，不足 30 种时展示全部',
                    '功能分析模块新增水平差异比较热图。支持 Type/Subtype 展示，默认展示 Top30 功能，不足30种时展示全部',
                    '解决部分项目调顺序参数失败问题',
                    '解决部分项目上传失败问题',
                    '解决部分项目运行失败问题',
                ]
            },
            {
                updateTime: '2026/01/23',
                content: [
                    '新增种水平（Species）物种组成可视化分析。覆盖堆积冲击图、柱状图、水平柱状图、气泡图、聚类热图、未聚类热图等多种图表类型，更精细地展示物种丰度在样本间的变化。',
                    '拓展种水平分析能力。新增08-04-01 top物种分析、08-05-07 beta多样性距离聚类的层次聚类图、08-06-01 差异比较热图、08-06-02 差异比较气泡图、08-06-05 top10丰度比较、08-06-07 CAMP分析、08-08 随机森林、10 物种和功能溯源分析的种水平相关图，帮助快速定位核心物种与组间差异物种。',
                    '完善数据导出与报告生成：支持种水平分析结果的表格数据与图表文件导出，同时集成到整体分析报告中，确保全流程数据可追溯、可复用。'
                ]
            },
            {
                updateTime: '2026/01/09',
                content: [
                    '在KEGG 通路分析模块中新增LEfSe 差异分析，可筛选组间显著差异的功能通路，挖掘核心功能标志物',
                    '新增LEfSe 进化分支图与差异柱状图，直观展示差异通路的层级分布与富集效应',
                    '支持 LEfSe 分析结果的图表、表格与原始文件一键导出',
                    '优化结果检索与管理：将 LEfSe 分析结果集成至分析结果目录，支持关键词搜索快速定位，实现功能差异分析结果的高效管理与复用。'
                ]
            },
            {
                updateTime: '2025/12/29',
                content: [
                    '在物种和功能溯源分析模块中，将饼图展示升级为HTML 交互式格式，支持多分类学水平与多功能数据库的物种溯源可视化。',
                    '新增鼠标悬停、层级展开 / 收缩等交互功能，可直观查看各物种在不同功能背景下的丰度占比与分布规律',
                    '兼容 COG、KEGG、元素循环、抗性等28种数据库，满足多样化的研究分析需求。',
                    '支持图表下载，提升结果解读与协作效率。'
                ]
            },
            {
                updateTime: '2025/11/25',
                content: [
                    '对物种分析模块的LEfSe 分析绘图功能进行优化，新增LDA 值与pvalue 值可调参数。',
                    '支持用户自定义 LDA 效应值与 pvalue 显著性阈值，灵活筛选组间差异显著的 Biomarker。',
                    '提供便捷的参数调整交互（输入框 + 加减按钮），并支持一键重绘图表，实时查看筛选结果。'
                ]
            },
            {
                updateTime: '2025/09/26',
                content: [
                    '分析管理优化：在分析列表直接展示样本分组信息，支持快速查看详情，让样本结构一目了然',
                    '默认分析管理：将系统默认分析纳入管理列表，且标记为不可删除，保障核心数据安全。',
                    '软件参数下载：新增分析软件与参数下载功能，可导出完整工具链与配置。'
                ]
            },
            {
                updateTime: '2025/08/15',
                content: [
                    '统一分析脚本，优化上传初始化效率，上传后不需要完全执行，测试创建分析结果需要时间20分钟左右。',
                    '解决部分预览顺序显示问题。',
                ]
            },
            {
                updateTime: '2025/08/01',
                content: [
                    '增加部分图片可修改行列数据参数（热图，柱状图，PCA等基本完善）',
                    '解决部分图片top数参数修改无效问题',
                    '分析数量增加限制，默认最大分析数量为5',
                    '表格文件显示所有数据，并支持搜索排序（之前只显示前100行）',
                    '解决“物种和功能溯源分析”中顺序错乱问题（以按照物种顺序排序）',
                    '增加PCA横纵坐标范围修改参数',
                ]
            },
            {
                updateTime: '2025/07/15',
                content: [
                    '无分组流程更新（上传需要上传目录中存在samples.txt）',
                    '物种注释表筛选功能，目前支持Identity%，IdentityLen，Evalue，Type的过滤（部分注释表中没有这些字段的数据库暂不支持筛选）',
                ]
            },
            {
                updateTime: '2025/07/07',
                content: [
                    '报告下载功能增加凌恩下载器下载方式，并注明推荐使用',
                    '06.基因丰度计算增加表profile/reads.txt（新分析才会生效）',
                    '项目背景增加分析员邮箱',
                ]
            },
            {
                updateTime: '2025/06/30',
                content: [
                    '下载报告添加对应的pdf报告',
                    '离线报告中缺少的图不展示图片和对应描述信息',
                ]
            },
            {
                updateTime: '2025/06/20',
                content: [
                    '物种功能注释文件展示优化',
                    '数据文件结果优化，并解决文件夹和报告不对应的问题',
                    '优化离线报告样式',
                    '优化重新绘制界面',
                    '原始数据状态优化（无原始数据不会显示菜单，存在原始数据会显示对应状态）',
                    '分组管理中添加样本筛选功能',
                ]
            },
            {
                updateTime: '2025/06/13',
                content: [
                    '优化部分文件显示顺序和显示结构，修改部分菜单水平平铺显示',
                    '补充部分图片作图数据，增加可重绘的图片（如：UPGMA聚类图，特异性-占有率图等）',
                    '物种分析、功能分析、物种和功能溯源分析增加新模块标识',
                    '补充部分表格文件（如：SARG/subtype.profile.xls）',
                    '增加binning类型MAGs CRISPR元件的鉴定',
                    '网页新增分析说明和常见问题功能',
                    '离线报告删除"分析方法、常见问题“等 仅保留分析报告解读部分',
                    '离线报告目录结构更改与在线报告一致',
                    '修改报告文字',
                ]
            },
            {
                updateTime: '2025/06/06',
                content: [
                    '更新宏基因组新流程',
                    '优化网页界面',
                    '优化报告中的文字信息',
                    '解决部分作图文件不能下载的问题',
                    '报告名称优化',
                    '优化样本管理',
                    '新建分析移动至分析管理',
                    '同分组 同样本在已有分析的情况下不允许再次创建分析',
                    '优化渲染，对于部分结果改为二维表格选择（如08.物种分析/02.Alpha多样性分析/02.Alpha多样性比较分析）',
                ]
            },
            {
                updateTime: '2025/04/10',
                content: [
                    '报告模板描述优化'
                ]
            },
            {
                updateTime: '2024/01/15',
                content: [
                    '增加binning类型项目',
                    '优化项目结构，分析可根据文件判断忽略模块',
                    '优化表格解释',
                    '修改项目上传文件功能',
                    '新增氢酶注释数据库、碳循环数据库、多酚代谢数据库注释',
                    '修复图片切换不刷新问题',
                    '原始数据下载记录：新增总下载次数',
                ]
            }
        ]
    },
    {
        sysName: '转录组交付系统（2.0）',
        updateLog: [
            {
                updateTime: '2026/10/23',
                content: [
                    '火山图新增参数标签字体大小，散点大小，统计信息文字大小，坐标轴线条宽度，字体样式',
                    '解决富集气泡图横轴范围参数修改异常的问题',
                    'WGCNA分析结果softPower.txt 改为输出「摘要 3 行 + 全部 23 个 power 的拟合指标表」',
                    '优化WGCNA分析，模块特征基因统一按 softPower 加权计算',
                    'WGCNA流程新增「剔除全样本表达量 <1 基因」的前置过滤',
                    '解决项目基因注释结果图显示异常的问题'
                ]
            },
            {
                updateTime: '2026/07/14',
                content: [
                    '解决部分项目调整绘图参数失效的问题',
                    '解决部分项目运行失败且项目部分内容不显示的问题',
                    '修复部分项目富集结果图、网络图结果显示异常的问题',
                    '解决部分原核项目缺少注释柱形图的问题',
                    '优化系统中标题展示：善于绘图，精于解读'
                ]
            }, {
                updateTime: '2026/06/05',
                content: [
                    "优化GSEA分析，增加 GSEA富集结果气泡图，GSEA结果总表，并在结果中生成svg格式高清结果图片",
                    "解决原核差异基因表达量热图异常的问题",
                    "WGCNA结果添加模块与性状的相关性分析作图数据文件"
                ]
            },
            {
                updateTime: '2026/05/21',
                content: [
                    '解决部分项目自定义差异基因-文件筛选报错的问题',
                    '富集柱状图/富集气泡图增加top参数',
                    '解决样本相关性热图字体大小修改参数异常问题',
                    '解决真核多组流程缺少富集柱状图/富集气泡图的问题',
                ]
            },
            {
                updateTime: '2026/05/15',
                content: [
                    '差异基因注释KEGG注释要添加 PathWay（通路号）',
                    '富集分析 GO和KEGG富集气泡图、柱状图加上GO号、KO号',
                    '解决部分项目差异基因热图top数修改异常问题',
                ]
            },
            {
                updateTime: '2026/05/09',
                content: [
                    '真核差异基因表达趋势折线图，新增配套数据文件 fpkm.clusters.gene.anno.xls、tpm.clusters.gene.anno.xls，文件包含各 Cluster 对应的差异基因明细',
                    '统一差异分析过滤参数，FC 倍数、Q 值阈值均采用分析员配置参数，保持参数一致、结果一致',
                    '解决项目调整绘图参数失败问题',
                    '解决项目富集气泡图显示异常的问题',
                    '解决项目高级分析运行失败/新建分析失败的问题',
                    '优化火山图精修图片展示情况',
                ]
            },
            {
                updateTime: '2026/04/13',
                content: [
                    '优化显著差异基因列表，logFC列名优化为logFC(组名A/组名B)的形式，添加分组对应的平均表达量，列名如：Mean(A)',
                    '优化：解决项目自定义差异基因筛选异常、报错问题',
                    '优化真核差异基因注释模块，新增DEG.pathway.top 上下调差异基因 KEGG 注释柱形图，解决通路过多导致的名称重叠、图片模糊问题',
                    'DEG.pathway.top 上下调差异基因 KEGG 注释柱形图 增加top 参数，可自定义top数',
                    'AI输入框支持折叠 / 收缩，为对话列表释放更多展示空间',
                    'AI输入框支持自定义拉伸，适配长文本输入',
                    '解决部分项目调坐标轴参数失败问题',
                    '解决项目高级分析加载过慢问题',
                    '解决部分项目运行失败问题',
                ]
            },
            {
                updateTime: '2026/04/03',
                content: [
                    'AI 报告解读模块新增 AI 使用技巧 提醒功能，帮助用户规范提问，提升 AI 解读准确性',
                    'AI使用技巧提醒 采用可折叠式设计：初始界面展示精简提示，展开后提供 8 条实用提问与交互技巧，覆盖全流程使用场景',
                    '适配不同交互状态：初始页、展开页、提问后状态自动适配，不干扰主对话流程',
                ]
            }, {
                updateTime: '2026/03/27',
                content: [
                    '优化转录组 AI 解读报告，正式升级为 AI 报告解读 Powered by 凌恩转录智能体',
                    'AI对话智能查询优化，默认支持表格数据检索',
                    '手动选择文件可显著提升报告生成质量，同时提示：选择文件会增加 Token 消耗。',
                    '修复部分项目AI解读报告中数据文件显示异常',
                    '修复部分分析报错问题；针对差异基因、富集基因等结果为空的数据异常情况，自动拦截并禁用 AI 功能，避免无效调用与报错。',
                    '解决部分项目运行失败的问题',
                    '解决差异基因热图执行慢的问题，现在默认生成top100（按照FDR值从小到大排序）的基因热图，可以通过top参数修改。',
                ]
            }, {
                updateTime: '2026/03/20',
                content: [
                    '优化 AI 相关功能：将 AI token 可修改额度控制上限调整为项目样本数量 × 1 亿，权限开放至技术支持和管理员',
                    '为 AI 对话模块新增安全防护措施，规范交互内容与使用行为，保障平台使用安全及 token 额度的合理管控。',
                    '修复功能异常问题：解决原核流程差异基因注释表格部分内容未显示的问题，确保注释信息完整可查。',
                    '优化搜索体验：修复项目类型无法搜索的问题，提升项目检索效率。',
                    '优化报错提示：完善 WGCNA 流程报错信息，当出现样本不足或差异基因不足的情况时，给出更清晰、易懂的提示，便于问题排查。',
                    '解决转录组部分项目高级分析—WGCNA分析运行失败问题。',
                    '解决部分项目下载的数据表存在异常问题。',
                ]
            }, {
                updateTime: '2026/03/13',
                content: [
                    'AI 报告智能解读功能，支持根据差异基因、GO 富集、KEGG 通路文件，自动生成专业解读内容，可对转录组分析全流程报告进行智能解读',
                    '内置 4 套提示词模板，开箱即用，无需复杂配置即可完成标准解读。',
                    '模板 1：关注基因，针对特定目标基因的表达、差异及功能进行解读',
                    '模板 2：关注功能，聚焦差异基因的功能注释与富集结果解读',
                    '模板 3：关注通路，针对关键信号通路的富集分析与调控机制解读',
                    '模板 4：关注基因 / 功能 / 通路，支持多维度组合解读，满足复杂科研场景',
                    '支持多轮交互式对话，可根据需求追问、调整，让解读结果更贴合分析目标。',
                    '为每个项目提供 2000 万 token 免费额度，满足日常解读与多轮对话使用。',
                    '支持管理员与技术支持人员手动修改项目 token 额度。',
                ]
            },
            {
                updateTime: '2026/01/30',
                content: [
                    '上线转录组AI报告解读初版。',
                    '上线关注基因的解读报告策略和智能体',
                    '上线关注功能的解读报告策略和智能体',
                    '上线关注通路的解读报告策略和智能体，并针对性优化',
                    '支持智能体结果信息保存和长链模式思考',
                    '支持结果文件预览和分批次加载',
                    '对标主流智能交互agent，更简洁的UI设计和用户体验优化。'
                ]
            },
            {
                updateTime: '2026/01/23',
                content: [
                    '自定义差异基因功能新增上传基因列表文件功能。支持用户通过上传 GeneID 列表文件，精准筛选目标差异基因集合，满足针对特定基因集开展后续富集分析、转录因子分析等研究的需求。',
                    '兼容 FPKM/TPM 两种数据类型，可根据项目数据格式灵活切换筛选条件。',
                    '内置操作流程说明，并提供示例文件下载，帮助用户快速掌握文件格式要求，降低使用门槛，提升分析效率。',
                    '支持预览筛选结果并一键执行，高效生成目标基因集的差异分析结果。',
                    'WGCNA优化流程，解决 best power参数不一致的问题，输出softPower.xls文件，文件内含本次分析选定的 best power值 以及全部power值的 R2、MeanConnectivity值'
                ]
            },
            {
                updateTime: '2026/01/09',
                content: [
                    '在富集分析模块中新增自定义筛选功能，支持对富集分析结果进行筛选。',
                    '提供灵活的筛选组合，可按基因类型（所有 / 上调 / 下调）、PValue 显著性阈值（如默认≤0.05）及ID 精准搜索（支持英文逗号分隔批量输入）进行多维度过滤，精准锁定研究关注的富集基因集。',
                    '支持实时预览筛选结果，并可对列表进行排序、搜索，方便快速核对。',
                    '沿用 “修改筛选条件→确认筛选→开始运行” 的三步操作流程，与自定义差异基因功能保持交互一致性。',
                    '差异基因GO/KEGG富集散点图新增top 数可调参数，支持自定义展示富集结果的条目数量（默认 30 条）。',
                    '支持在总差异、上调、下调三类基因富集结果间切换，结合 top 数参数精准筛选核心富集条目。',
                    '提供便捷的加减按钮调整 top 数，调整后一键绘制图表，实时预览不同数量级的富集结果。'
                ]
            },
            {
                updateTime: '2025/12/12',
                content: [
                    '解决富集图默认顺序、默认颜色异常问题',
                    '解决部分分析无法新建分析成功问题',
                    '解决部分项目上下调基因数量异常问题',
                    '解决部分项目结果目录不显示的问题',
                    '解决部分项目下载报告存在图片内容缺失的问题',
                    '解决项目分析运行失败问题',
                    '优化项目自定义差异基因功能，解决该功能失效的问题'
                ]
            },
            {
                updateTime: '2025/12/1',
                content: [
                    '完善自定义差异基因筛选功能，新增对GeneID 及各类注释信息的筛选能力，实现更精准的目标基因定位。',
                    '支持 PValue、FDR、LogFC 阈值与基因 ID / 注释信息的多条件组合筛选，满足多样化研究需求。',
                    '提供便捷的批量输入与条件重置操作，筛选后可实时预览结果列表，方便快速核对。',
                    '支持在 FPKM 与 TPM 两种表达量数据类型间切换，适配不同项目的数据分析流程，保证筛选结果与后续分析无缝对接，提升分析灵活性。'
                ]
            },
            {
                updateTime: '2025/11/25',
                content: [
                    '差异基因热图优化,增加参数可控制是否显示基因ID',
                    '优化FPKM/TPM结果布局',
                    '优化表格数据显示, 由显示表格前100行数据修改为显示所有数据',
                    '优化表格布局，解决部分表格数据太少出现空白区域的问题'
                ]
            },
            {
                updateTime: '2025/11/14',
                content: [
                    '优化差异基因 GO/KEGG 富集散点图可视化配置：新增背景色、坐标轴颜色、格子边框颜色可调参数',
                    '提供颜色选择器与十六进制色值输入框，可精准设置坐标轴颜色（如默认#ebebeb）、背景色（如默认#ebebeb）及格子边框颜色（如默认#FFFFFF），实现图表细节的个性化调整。',
                    '参数修改后可点击「绘制」按钮实时更新图表，直观预览颜色效果，便于快速迭代调整至理想视觉呈现。',
                    '颜色参数配置适用于总差异基因、上调差异基因、下调差异基因三类富集结果图表，保证不同数据集下的视觉风格统一可控。'
                ]
            },
            {
                updateTime: '2025/11/03',
                content: [
                    '在高级分析模块中新增Venn 分析功能，用于分析多组差异基因集合的重叠与特有基因。',
                    '提供完整的任务管理能力，支持新建分析、查看分组样本信息与任务状态。',
                    '输出可视化 Venn 图与详情表，直观展示各组基因数量及交集分布，支持结果下载与检索。',
                    '支持多组比较组合切换，满足不同研究场景下的基因集交集分析需求。',
                    '解决差异基因信息表没有注释信息的问题',
                    '解决部分分析图表工具失效的问题',
                    '差异基因注释柱形图新增图表工具模块，支持对图例展示与排列进行自定义调整。',
                    '可自由勾选 / 隐藏分类条目，通过浅蓝色 / 灰色切换展示状态。',
                    '支持拖动条目调整排列顺序，按需定制图表的展示层级与逻辑',
                    '调整后一键重绘，与其他参数联动，快速生成理想的可视化图表'
                ]
            },
            {
                updateTime: '2025/10/20',
                content: [
                    '基因表达差异分析模块新增差异基因热图与差异基因表达趋势折线图两类可视化图表。',
                    '差异基因热图：聚类展示差异基因表达模式，支持多参数自定义配置，直观呈现样本与基因间的表达差异',
                    '趋势折线图：对差异基因分群后展示表达变化趋势',
                    '同步完善图表工具，操作便捷，体验连贯',
                    '完善图表工具功能，为PCA 图、箱线图、水平密度曲线图等核心图表新增样本顺序调整能力。',
                    '支持拖动样本标签调整展示顺序，同时可点击控制样本显示 / 隐藏，实现精准的可视化筛选。',
                    'WGCNA 分析模块新增表型数据文件状态展示与下载功能。',
                    '在分析数据查看弹窗中，清晰标识分析是否包含表型数据文件。',
                    '对已上传表型数据的任务，支持直接下载对应的表型数据文件',
                    '增加基因转录因子注释结果（需要分析人员上传对应文件才存在该模块）。'
                ]
            },
            {
                updateTime: '2025/09/26',
                content: [
                    '优化分析管理，直接显示对应分组信息',
                    '默认分析添加到分析管理中（该分析不能删除）',
                    '分析软件支持下载'
                ]
            },
            {
                updateTime: '2025/09/12',
                content: [
                    '新增查看分析方法（中文）',
                ]
            },
            {
                updateTime: '2025/05/06',
                content: [
                    '解决部分报告下载为模板报告的问题',
                    '解决部分报告下载没有表格的问题',
                ]
            },
            {
                updateTime: '2025/04/10',
                content: [
                    '转录组分析数量上限设置功能，可设置普通分析最大数量和高级分析最大数量',
                    '优化原核报告，解决部分表格缺失问题',
                    '优化原核多组流程，解决部分分析异常情况',
                ]
            },
            {
                updateTime: '2025/03/28',
                content: [
                    '添加创建多组分析功能',
                    '在小工具栏增加下载核苷酸和蛋白序列功能',
                    'WGCNA表型数据修改为选填',
                    '创建项目后自动执行默认差异比较的分析',
                    '在高级分析中增加样本统计分析',
                    'PCA添加置信椭圆，样品名称是否显示的功能',
                    'WGCNA和时序分析添加每个模块的表达矩阵',
                    '自定义差异基因可以选择FPKM/TPM',
                    '真核两组增加GSEA分析',
                    '加入项目问题说明合集',
                    'WGCNA补充节点和边文件',
                ]
            },
            {
                updateTime: '2025/03/12',
                content: [
                    '结果图片精修功能，修改后可以保存替换报告中的文件',
                    'wgcna根据trait表型文件新建分析',
                    '时序分析在创建时通过设置的分组顺序可控制折线图顺序',
                    '转录组基因选择效率优化',
                    '颜色展示前端ui优化',
                    '样本管理展示基因表',
                    '结果树功能，可以下载一个文件或者一个文件夹（文件夹会下载对应压缩包）',
                ]
            },
        ]
    },
    {
        sysName: '代谢组交付系统',
        updateLog: [
            {
                updateTime: '2026/10/10',
                content: [
                    '组间差异代谢物丰度热图增加top参数',
                    '解决项目结果包显示异常问题',
                    '解决项目因分组数过多导致的运行失败问题',
                    '解决项目结果内容显示异常的问题',
                ]
            }, {
                updateTime: '2026/08/07',
                content: [
                    '密度图绘图脚本优化，优化样本图例信息排列，解决大样本量项目图例异常问题',
                    '解决两组间差异分析中，差异倍数计算“两位小数向下取整”，会导致一些刚刚超过阈值的代谢物被过滤掉',
                    '解决多组分析通路注释数据表显示异常的问题',
                    '优化差异物KEGG注释通路图的描述信息',
                    '解决运行pca图显示异常的问题',
                    '解决项目界面显示报错的问题',
                ]
            }, {
                updateTime: '2026/07/14',
                content: [
                    '优化随机森林当遇到两组差异较小时，可能出现 “breaks are not unique” 的报错',
                    '代谢组小提琴图绘图脚本优化',
                    '优化差异代谢物筛选BUG,适配老版本数据',
                    '优化聚类热图脚本',
                    '优化系统中标题展示：善于绘图，精于解读',
                ]
            }, {
                updateTime: '2026/06/24',
                content: [
                    '解决代谢物定量丰度可视化小提琴图、密度分布图绘图问题',
                    '优化差异代谢物相关性分析热图代谢物过多导致图片无法加载问题（大于1000时只取按照P值从小到大排序的前100个进行绘制）',
                    '解决差异代谢物通路注释没有上下调数据列bug',
                    '更新差异代谢物KEGG数据库注释',
                    '支持组内样本数小于3的分析',
                    '解决老项目自定义差异基因报错的问题',
                    '解决项目vip图丰度高低显示异常的问题',
                ]
            },
            {
                updateTime: '2026/05/15',
                content: [
                    '修改差异代谢物结果可视化差异代谢物火山图、差异代谢物棒棒糖图、差异倍数柱形图、差异代谢物雷达图标签展示（显示ID+代谢物名称）',
                    '修改富集分析可视化图片  KEGG富集散点图、KEGG富集柱状图、KEGG富集气泡图、KEGG富集鲁棒图的标签展示（显示KO号+代谢物）',
                    '优化差异代谢物筛选执行逻辑',
                ]
            },
            {
                updateTime: '2026/04/16',
                content: [
                    '代谢组 差异代谢物分析 模块新增 自定义差异代谢物 功能，支持多维度灵活筛选目标代谢物',
                    '支持自定义筛选，两组提供logFC、PValue、VIP值筛选，多组提供PValue、VIP值筛选；同时可支持精准搜索，实时预览筛选结果',
                    '支持上传文件筛选，并提供示例文件',
                    '新增最大分析数量修改，权限开放至分析、技术支持和管理员',
                    '解决部分项目火山图重绘Bug',
                    '解决部分项目pca图调整顺序失效的问题',
                ]
            },
            {
                updateTime: '2026/04/08',
                content: [
                    'AI 报告智能解读功能，支持根据差异代谢物、KEGG通路富集文件自动生成专业解读内容，可对代谢组分析全流程报告进行智能解读',
                    '内置 3 套提示词模板，开箱即用，无需复杂配置即可完成标准解读。',
                    '模板 1：关注差异代谢物，针对特定目标代谢物进行解读',
                    '模板 2：关注KEGG通路富集，针对关键信号通路的富集分析与调控机制解读',
                    '模板 3：关注差异代谢物 / KEGG通路富集，支持多维度组合解读，满足复杂科研场景',
                    'AI 使用技巧提醒功能，帮助用户规范提问，提升 AI 解读准确性',
                    'AI输入框不仅支持折叠 / 收缩 还支持自定义拉伸，为对话列表释放更多展示空间',
                    '为每个项目提供 2000 万 token 免费额度，满足日常解读与多轮对话使用',
                    '支持管理员与技术支持人员手动修改项目 token 额度',
                    '解决分析重新执行bug',
                    '解决重绘top参数无效bug',
                    '解决PCA图重绘颜色修改无效bug'
                ]
            }, {
                updateTime: '2026/02/28',
                content: [
                    '完善 全模块图表工具：覆盖代谢组分析核心可视化场景，包括代谢物鉴定及定量分析、样本间关系分析、组间比较统计、差异代谢物分析、差异代谢物的代谢通路富集分析',
                    '完善 9 类 核心图表的绘图参数：包括小提琴图、密度分布图、环形图、聚类树图、普氏分析图、随机森林图、富集鲁棒图、RSD 累计分布图、差异倍数柱形图。',
                    '提供统一可视化配置：支持布局、颜色、字体、排序等精细化调整，实现图表个性化定制。',
                    '优化交互体验：实时预览 + 一键重绘，高效调试出符合需求的专业可视化结果。',
                    '解决随机森林代谢物重复bug',
                    '解决上传QC样本判断问题'
                ]
            },
            {
                updateTime: '2026/01/23',
                content: [
                    '新增代谢物数据库注释HMDB模块可视化',
                    '新增代谢物定量分析可视化',
                    '新增样本间关系分析all类型',
                    '新增样本间聚类分析',
                    '新增代谢物组间差异随机森林分析',
                    '差异代谢物代谢通路富集分析新增多个可视化图形',
                    '两组新增组间比较统计普式分析',
                ]
            },
            {
                updateTime: '2025/11/20',
                content: [
                    '新增两组分析类型，支持两组样本的代谢组差异分析，与现有多组分析形成完整覆盖。',
                    '在分析管理列表中新增「分组状态」列，直观标识分析任务为「两组」或「多组」，便于快速识别样本结构。',
                    '优化两组样本的差异分析流程，更精准地筛选组间差异代谢物，提升分析效率。',
                    '新增每组单样本分析模式，针对无组内重复的实验设计优化分析流程。',
                    '每组单样本自动跳过PLSDA、OPLSDA、相关性分析等依赖组内重复的统计步骤',
                    '每组单样本差异代谢物结果仅生成雷达图，直观展示单样本间的代谢轮廓差异。',
                    '新增小样本量分析适配，当存在一组或两组仅 2 个样本时，自动跳过 PLSDA、OPLSDA，差异代谢物结果仅生成雷达图，保证小样本分析的科学性与可靠性。',
                    '优化多组分析样本限制：多组分析不支持分组内样本量小于 3 的情况。'
                ]
            },
            {
                updateTime: '2025/10/24',
                content: [
                    '新增多组分析类型，支持 3 组及以上样本的代谢组差异分析。',
                    '在分析管理列表中新增「多组」分组状态标签',
                    '3 组及以上样本的代谢组差异分析新增趋势分析',
                    '完成代谢组系统 UI 优化，实现与转录组、多样性、宏基因组系统的界面风格统一',
                    '统一页面布局、导航结构与视觉规范，包括左侧菜单、模块分区、表格样式与交互组件',
                    '提升全平台产品体验的连贯性与一致性，打造更专业、统一的组学分析工作台。'
                ]
            },
            {
                updateTime: '2024/02/11',
                content: [
                    '创建项目功能完成（脚本为/mnt/sdb/share/software/metabo-create.jar）。',
                    '重新绘制图片功能完成。',
                    '重跑分析完成（可以重新选择组间定量丰度差异倍数执行）',
                    'table文件表头解释',
                    '显示分析详情',
                    '优化绘图结果，增加可修改参数',
                    '自动分析项目邮件发送',
                    '解决分析详情中样本显示bug',
                    '增加审批人查看项目信息',
                    '更新兼容代谢新版本数据',
                ]
            }
        ]
    },
    {
        sysName: '转录组和代谢组联合分析交付系统',
        updateLog: [
            {
                updateTime: '2026/10/10',
                content: [
                    '分析报告支持批量下载',
                    '新建项目时支持合同号搜索项目号',
                    '解决分析运行失败的问题',
                    '新建分析处优化样本自动匹配规则，根据对照组和实验组相对应配对',
                ]
            },
            {
                updateTime: '2026/6/30',
                content: [
                    '支持销售创建联合分析项目',
                    '更改新建项目逻辑为只选择对应转录代谢项目',
                    '更改新建分析逻辑，需要选择对应的转录组、代谢组的分析',
                    '每个联合分析项目内新建分析套数限制20套',
                    '优化项目显示，新增关联项目的样本数量、样本信息列的展示',
                    '重跑分析可修改分组样本信息',
                    '.新增新建项目的界面提示：必须同时有转录组和代谢组项目才能使用联合分析功能!您当前暂无转录组和代谢组项目!，支持跳转至转录组/代谢组交付系统',
                    '解决项目新建分析运行失败的问题',
                    '解决项目分析搜索不显示的问题',
                ]
            }, {
                updateTime: '2026/6/17',
                content: [
                    '上新转录和代谢联合分析交付系统',
                    '支持客户创建联合分析项目',
                    '必须同时有转录组和代谢组项目才能进行联合分析',
                    '页面与其他交付系统保持风格一致。涵盖项目号、关联信息、创建时间、备注、操作等。',
                    '支持新建分析，支持样本自动配对和导入文件配对，提供导入配对样本、分组模板文件',
                    '提供11大模块分析。涵盖相关性分析、富集分析、普氏分析等',
                ]
            },
        ]
    },
    {
        sysName: '多样性和代谢联合分析交付系统',
        updateLog: [
            {
                updateTime: '2026/10/10',
                content: [
                    '分析报告支持批量下载',
                    '新建项目时支持合同号搜索项目号',
                    '解决分析运行失败的问题',
                ]
            },
            {
                updateTime: '2026/7/14',
                content: [
                    '上新多样性和代谢联合分析交付系统',
                    '支持客户、销售创建联合分析项目',
                    '必须同时有多样性和代谢组项目才能进行联合分析',
                    '增加新建项目的界面提示:必须同时有多样性和代谢组项目才能使用联合分析功能!您当前暂无多样性和代谢组项目!，支持跳转至多样性/代谢组交付系统',
                    '页面与其他交付系统保持风格一致。涵盖项目号、关联信息、创建时间、备注、操作等',
                    '支持新建分析，支持样本自动配对和导入文件配对，提供导入配对样本、分组模板文件',
                    '提供6大模块分析。涵盖相关性分析、普氏分析等',
                    '每个联合分析项目内新建分析套数限制20套（管理员、技术支持可修改）',
                    '限制项目创建数量（销售和客户限制2套；分析、管理员、技术支持不作限制）',
                    '增加项目信息显示，新增关联项目的样本数量、样本信息列的展示',
                    '重跑分析可修改分组样本信息',
                    '限制运行分析数量，同一项目只允许两个分析同时运行',
                ]
            },
        ]
    },
    {
        sysName: '鱼类eDNA交付系统',
        updateLog: [
            {
                updateTime: '2026/10/26',
                content: [
                    '正式上线  鱼类eDNA交付系统',
                    '页面与其他交付系统保持风格一致。涵盖项目号、创建时间、备注、操作等信息',
                    '物种注释管理展示注释表信息，支持自行上传物种注释表',
                    '分析管理界面展示注释分析相关信息，执行时间、分析名等',
                    '分析管理支持新建分析，可选择物种注释表',
                    '支持 调整物种注释 重新分析',
                ]
            },
        ]
    },
    {
        sysName: '裸测项目交付系统',
        isNoCustomer: true,
        updateLog: [
            {
                updateTime: '2026/08/12',
                content: [
                    '新增原始数据到期邮件提醒（剩余5天和剩余1天）;',
                    '原始数据 抓取失败尝试时间改为2小时;',
                    '项目同时有链接和硬盘两种释放方式，两种都保留;',
                    '解决部分项目状态显示失败的问题;',
                    '解决项目下载报告列显示异常的问题;',
                ]
            }, {
                updateTime: '2026/07/23',
                content: [
                    '合并硬盘释放项目，合并展示',
                    '硬盘释放，增加硬盘大小信息，并用颜色区分硬盘类型',
                    '更新 三代测序项目 原始数据压缩文件样本匹配规则',
                    '解决 上传文件异常问题',
                    '解决 硬盘释放项目未进入系统问题',
                    '删除 硬盘释放项目 分享功能',
                ]
            }, {
                updateTime: '2026/06/23',
                content: [
                    '解决硬盘记录未添加的问题',
                    '展示硬盘来源，对于借用硬盘显示硬盘返回时间',
                    '新增数据状态',
                    '添加样本信息，样本数量列',
                    '硬盘释放增加数据截图查看',
                ]
            }, {
                updateTime: '2026/06/22',
                content: [
                    '纯分析重试放项目-使用处理人发送邮件',
                    '报告与原始数据分离，报告不过期清空',
                    '释放方式改为释放详情，并展示释放记录，整合样本列表查看',
                    '增加原始数据信息，硬盘信息的展示',
                    '解决自动审批根据备注判断错误的问题',
                    '增加原始数据与样本列表比对，解决有数据未正确抓取的问题',
                    '移除样本数量、样本信息、创建时间列的展示',
                ]
            }, {
                updateTime: '2025/11/21',
                content: [
                    '对原始数据表格及报告，仅展示已释放的样本',
                    '上传中的原始数据将会在数据同步火山云完成后同步发送邮件',
                    '解决原始数据上传丢失的问题'
                ]
            },
            {
                updateTime: '2025/10/13',
                content: [
                    '新项目的原始数据交付改为火山云释放',
                ]
            },
            {
                updateTime: '2025/07/07',
                content: [
                    '新增项目分批释放原始数据功能',
                    '新增审批查看当前释放对应样本信息',
                    '新增原始数据查看已释放所有样本信息',
                    '原始数据上传优化为上传释放样本对应原始数据压缩包',
                ]
            },
        ]
    },
    {
        sysName: '其他类型项目交付系统',
        updateLog: [
            {
                updateTime: '2026/10/28',
                content: [
                    '界面新增 原始数据释放状态信息展示：释放方式   内容包含：释放时间、失效时间以及硬盘释放相关信息',
                    '项目内界面同步展示原始数据释放信息',
                    '界面新增  下载原始数据  功能',
                ]
            },
            {
                updateTime: '2025/03/28',
                content: [
                    '界面ui优化',
                ]
            },
            {
                updateTime: '2024/11/12',
                content: [
                    '原始数据下载记录：新增总下载次数',
                ]
            },
        ]
    },
]
